//import moment from "moment";
import AdmissionPatientCard from "../../admissionPatientCard";
import React, {useEffect, useMemo, useRef, useState} from 'react';
import makeStyles from "@mui/styles/makeStyles";
import {useDispatch, useSelector} from "react-redux";
import {
    countDays,
    getAdmissionType,
    getConfig,
    getHourHeight,
    getMarkedOperation,
    getOperationToScroll,
    reload,
    setHourHeight,
    getOperationsObject,
    setMarkedOperation,
    setPatientsListToReschedule,
    getPatientsListToReschedule,
    setAdmissionType,
    setOperationsStatus,
    setOperationToScroll, setNewView, getDraftModeOn, setDraftModeOn,
} from '../../../../store/reducers/booked_admissions';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {MenuItem, Paper, Tooltip} from '@mui/material';
import Menu from '@mui/material/Menu';
import IconButton from "@mui/material/IconButton";
import AgyleDialog from "../../../../components/modal/agyleDialog";
import {admissionStatusTypes, admissionViewTypes, CalendarViews} from '../../bookedAdmissions';
import SessionModal, {initNewSession, mapTheatreObject} from '../../header/sessionModal';
import useOpenState from "../../../../hooks/useOpenState";
import clsx from "clsx";
import LockTimeSlotModal from "../modals/lockTimeSlotModal";
import {proceduresLen} from '../../../bookAdmission/workList';
import _ from "lodash";
import {agylePref} from '../../../../store/reducers/preferences';
import LockIcon from '@mui/icons-material/Lock';
import API from '../../../../app/api';
import CircleIcon from '@mui/icons-material/Circle';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';
import APIForm from '../../../../app/apiForm';
import Slider from '@mui/material/Slider';
import {setSnackbar} from '../../../../store/reducers/globals';
import AddIcon from "@mui/icons-material/Add";
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import EditIcon from '@mui/icons-material/Edit';
import config from "../../../../app/config";
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {setAdmissionDnD} from '../../../../store/reducers/dragAndDrop';
import Grid from '@mui/material/Grid';
import RemoveIcon from '@mui/icons-material/Remove';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import CloseIcon from '@mui/icons-material/Close';
import {hasBAPermission, Permissions} from '../../../../store/reducers/user';
import moment from 'moment/moment';
import 'moment-timezone';
import NotesIcon from '@mui/icons-material/Notes';

export const BACalendarStyles = makeStyles((theme) => ({
    day: {
        minWidth: 350,
        margin: "0 5px 0 5px",
        position: "relative",
        borderRadius: 10,
    },
    patientCardBackground: {
        backgroundColor: theme.palette.admissionForm.patientCardBackground,
    },
    dayWithBorder: {
        minWidth: 200,
        margin: "0 5px 0 5px",
        position: "relative",
        border: "1px solid #626466",
        borderRadius: 10,
    },
    session: {
        position: "absolute",
        color: "white",
        zIndex: 2,
        borderRadius: 10,
        width: "100%",
    },
    sessionWithBorder: {
        position: "absolute",
        border: "1px solid #c0c6c7",
        color: "white",
        zIndex: 2,
        borderRadius: 7,
        width: "100%",
    },
    locked: {
        border: "3px solid",
        borderColor: theme.palette.mode === "dark" ? "#F7A202" : "#8114ac",
    },
    text: {
        margin: "3rem",
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        zIndex: 1,
        transform: "rotate(90deg)",
        WebkitTransform: "rotate(90deg)",
        color: "#c6afaf"
    },
    itemContent: {
        position: "absolute",
        width: "100%",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#000000",
    },
    itemContentHoldingPen: {
        width: "100%",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#000000",
    },
    itemTimeSlot: {
        position: "absolute",
        width: "100%",
        color: theme.palette.mode === "dark" ? "#F7A202" : "#8114ac",
        background: theme.palette.mode === "dark" ? "#252525" : "#e3e3e3",
        height: "196.667px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "15px",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: theme.palette.mode === "dark" ? "#F7A202" : "#8114ac",
        overflow: "hidden"
    },
    dayHeader: {
        height: 40,
        background: theme.palette.bookAdmissions.dayHeader,//"#373737",
        borderRadius: "10px 10px 0 0",
        margin: "0px",
        display: "flex",
        paddingLeft: 10,
        alignItems: "center",
        justifyContent: "space-between",
        "&.today":{
            background: "#2180F7",
            color: "white"
        }
    },
    dayDetails: {
        height: 45,
        background: theme.palette.bookAdmissions.dayHeader,//"#373737",
        borderRadius: " 0 0 10px 10px",
        margin: "5px 0px 7px 0px",
        fontSize: "13px",
        color: theme.palette.bookAdmissions.textColor,
        transition: "background-color 600ms linear",
        overflow: "hidden"
    },
    sessionHeader: {
        transition: "display 600ms linear",
        display: "none", alignItems: "center", justifyContent: "center", height: 50, color: "black", textAlign: "center"
    },
    specColorMarker: {
        height: "32px",
        width: "4px",
        marginLeft: "6px",
        borderRadius: "14px",
        marginTop: "2px"
    },
    noSessionLabel: {
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700
    },
    flexCenter: {
        display: "flex",
        alignItems: "center",
    },
    holdingIcon: {
      color: "#2180F7",
      border: "1px solid #2180F7",
        borderRadius: 5,
        width: 25,
        textAlign: "center",
        marginLeft: 5
    },
    dayNumber: {
        height: "35px",
        width: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold"
    },
    specCode: {
        fontSize: 11,
        display: "flex",
        alignItems: "center",
        marginRight: 5
    },
    time: {
        fontSize: 11
    },
    lockedSession: {
        fontSize: 11,
        color: theme.palette.mode === "dark" ? "#F7A202" : "#8114ac",
        display: "flex",
        marginLeft: 15,
        "& div": {
            display: "inline-flex",
            alignItems: "center"
        },
    },
    fullSession: {
        fontSize: 11,
        color: "#E25B61"
    },
    sessionPerson: {
        paddingLeft: 4,
        fontSize: 11
    },
    calendarContainer: {
        width: "calc(100vw - 350px)",
        height: "calc(100vh - 166px)",
        overflow: "auto",
        marginTop: 5,
    },
    timeLine: {
        position: "absolute",
        zIndex: 90,
        width: "100%",
        background: theme.palette.mode === "dark" ? "#1858af" : "#2180f7",
        height: 2,
        left: 52,
        top: 200
    },
    holdingNumber: {
        background: "#2180F7",
        color: "white",
        borderRadius: 6,
        minWidth: 20,
        textAlign: "center",
        marginLeft: 10
    },
    currentTime: {
        fontSize: 10,
        position: "absolute",
        zIndex: 99,
        background: theme.palette.mode === "dark" ? "#1858af" : "#2180f7",
        top: 200,
        left: 12,
        color: theme.palette.mode === "dark" ? "#f7f7f7" : "#ffffff",
        padding: "1px 7px",
        borderBottomLeftRadius: "5px",
        borderTopLeftRadius: "5px"
    },
    times: {
        position: "sticky",
        left: 0,
        zIndex: 8,
        background: theme.palette.background.default
    },
    timeLabel: {
        position: "absolute",
        background:  theme.palette.background.default,
        fontSize: 12,
        left: 10
    },
    dayHeaderContainer: {
        //  position: "sticky",
        minWidth: 350,
        margin: "0 5px 0 5px",
        top: 0,
        zIndex: 1000,
        background: theme.palette.background.default
    },
    headerLine: {
        width: "100%",
        //borderTop: "1px solid #626466",
        height: 8
    },
    calendarContent: {
        width: "fit-content",
        backgroundImage: "linear-gradient(to bottom, "+ theme.palette.bookAdmissions.sessionTimeLines+" 1px, transparent 1px)"
    },
    addSessionButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 50,
        fontWeight: "bold",
        fontSize: 20
    },
    addWorkstationButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 50,
        fontWeight: "bold",
        fontSize: 20
    },
    availableSlot: {
        textAlign: "center",
        fontSize: 11,
        border: "1px solid #626466",
        display: "flex",
        position: "absolute",
        borderRadius: 6,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        flexWrap: "wrap",
        overflow: "hidden",
        zIndex: -1,
        color: theme.palette.mode === "dark" ? "#ffffff" : "#111111",
        background: "transparent",// theme.palette.mode === "dark" ? "#222425" : "#ededed",
    },
    sliderHolder: {
        position: "absolute",
        width: 500,
        zIndex: 99,
        bottom: 0,
        right: 50,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    patientCardHolder: {
        width: 400,
        marginBottom: 20
    },
    timeModalBody: {
        marginBottom: 20
    },
    stickyDayContainer: {
        position: "sticky",
        top: 0,
        left: 20,
        zIndex: 1000,
        background: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    },
    stickyDayHolder: {
        display: "inline-flex",
        alignItems: "center"
    },
    stickyDayHolderItem: {
        width: 50,
        background: "#252525"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2",
        minWidth: 200
    },
    holdingContainer: {
        width: "220px",
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb",
        right: 75,
        zIndex: 11,
        top: "220px",
        borderRadius: "6px",
        border: "1px solid rgb(172, 175, 179)",
        position: "absolute",
        height: "calc(100% - 350px)",
        padding: "0 5px 5px 5px",
        textAlign: "center",
        transition: "all .2s linear"
    },
    holdingTitle: {
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "20px",
        letterSpacing: "0em",
        textAlign: "center",
        zIndex: 10,
        padding: 10,
        position: "sticky",
        top: 0,
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb",
        color: theme.palette.mode === "dark" ? "#ebebeb": "#252525",
    }
}))

export const generateColor = (code) => {
    if(!code) return "white";
    let asciiSum = code.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
    asciiSum = Math.abs((asciiSum - 1000)*6568);

    const hexCode = (asciiSum % 16777215).toString(16).padStart(6, '0');
    return "#" + hexCode;
}

const AgyleCalendarDays = (props) => {

    const classes = BACalendarStyles();
    const dispatch = useDispatch();

    const controller = new AbortController();
    const calendarScroll = useRef(null);

    const hoursCount = useRef(16);
    const headerHeight = 115;

    const [hoursToRender, setHoursToRender] = useState([]);
    const [state, setState] = useState(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

    const [clickedHour, setClickedHour] = useState(null);
    const [cardConfig, setCardConfig] = useState();
    const [timeLineVisible, setTimeLineVisible] = React.useState(false);
    const [clickedWorkStation, setWorkStation] = useState(null)

    const [stateDraft, setStateDraft] = useState(null)
    const [stateDataDraft, setStateDataDraft] = useState(null)

    const [sessionToEdit, setSessionToEdit] = useState([]);

    const open = Boolean(anchorEl);

    const [isEditSessionModalOpen, openEditSessionModal, closeEditSessionModal] = useOpenState(false, true);
    const [isTimeSlotModalOpen, openTimeSlotModal, closeTimeSlotModal] = useOpenState(false, true);
    const [isEndSurgeryModalOpen, openEndSurgeryModal, closeEndSurgeryModal] = useOpenState(false, true);
    const [isEditOperationTimeModalOpen, openEditOperationTimeModal, closeEditOperationTimeModal] = useOpenState(false, true);
    const [isSessionNoteModalOpen, openSessionNoteModal, closeSessionNoteModal] = useOpenState(false, true);

    const draftMode = useSelector(getDraftModeOn);
    const admissionType = useSelector(getAdmissionType);
    const configBA = useSelector(getConfig);
    const agylePreference = useSelector(agylePref);
    const markedOperation = useSelector(getMarkedOperation);
    const hourHeight = useSelector(getHourHeight);
    const operationToScroll = useSelector(getOperationToScroll);
    const operations = useSelector(getOperationsObject);

    const patientsListToReschedule = useSelector(getPatientsListToReschedule);
    const transferStartDate = config.bookAdmissionTransferStartDate? moment(config.bookAdmissionTransferStartDate,"DD/MM/YYYY"): moment();
    const timezone = config?.defaultTimezone || 'Europe/London';


    useEffect(()=>{
        if(operationToScroll) {
            if(document.getElementById("admission_card_scroll_"+operationToScroll)) {
                setTimeout(()=>{
                    document.getElementById("admission_card_scroll_"+operationToScroll).scrollIntoView({ block: 'center' });
                }, 10);
            }
        }
    }, [operationToScroll, state]);

    useEffect(()=>{
        return () => {
            controller.abort();
            dispatch(setPatientsListToReschedule([]))
        };

    },[])


    const mapOperationData = (admission, startTime) => {
        let tmpA = _.cloneDeep(admission);

        tmpA.consultant = tmpA.consultant != null && tmpA.consultant.hasOwnProperty("item") ? tmpA.consultant.item : tmpA.consultant;

        delete tmpA["href"];
        delete tmpA["patient"];
        delete tmpA["type"];
        delete tmpA["sessiosObj"];

        if(tmpA['status'] === "SEND")
            tmpA['status'] = "PENDING"

        tmpA.bookedDate = startTime;

        if(tmpA.overseeingConsultant) {
            tmpA.overseeingConsultant = {
                id: tmpA.overseeingConsultant.id,
                name: tmpA.overseeingConsultant.name,
            }
        }
        return tmpA
    }


    const handleCancelDraft = () => {
        dispatch(setDraftModeOn(false));
        setStateDraft(null);
        dispatch(reload());
    }
    const handleOpenDraftMode = () => {
        dispatch(setMarkedOperation(null));
        setStateDraft(() => {
            let tmpState = _.cloneDeep(state);
            if(tmpState[0].imported) {
                tmpState[0].containers.forEach((container)=>{
                    let startTime = getSessionStartDateAndTimeMoment(container.session);
                    container.session.day = startTime;

                    let minutes = 0;
                    container.items.forEach((item, index) => {
                        if(moment.tz(item.startTime,timezone).format("HH:mm") === "00:00"){
                            item.startTime = moment(startTime).add(minutes, "minutes");
                        }

                        minutes += item.timeLen;
                    });
                })

            }
            return tmpState
        })

        setStateDataDraft(props.data);
        dispatch(setDraftModeOn(true));
    }

    const handleResetDraftState = () => {
        setStateDraft(state)
    }
    const handleSaveDraftMode = () => {
        if(draftMode) {

            let admissionToUpdate = {};
            let sessionToSave = {};

            stateDraft.map((column)=>{
                _.forEach(column.containers, (container) => {

                    if(!sessionToSave.hasOwnProperty(container.session.id)){
                        sessionToSave[container.session.id] = container.session
                    }

                    container.session.bookedSessions.forEach((item) => {
                        delete item.overlap;
                        if(!admissionToUpdate.hasOwnProperty(item.operationId) && !item.lock){
                            admissionToUpdate[item.operationId] = item
                        }
                    })


                });
            })

            Object.keys(admissionToUpdate).forEach((itemKey) => {
                let item = admissionToUpdate[itemKey];
                if(item.operationId) {
                    API.admissionUpdate(mapOperationData(stateDataDraft[item.operationId], item.startTime), controller.signal).then(
                        (operation) => {

                        }
                    ).catch(error => {
                        dispatch(setSnackbar({
                            type: "error",
                            message: "Operation for "+ stateDataDraft[item.operationId].patientName + " don't save",
                        }));
                    });
                }
            })

            Object.keys(sessionToSave).forEach((sessionKey) => {
                let session = sessionToSave[sessionKey];
                let tmp = {
                    ...session,
                    theatre: mapTheatreObject(session.theatre),
                }

                API.theatreSessionsUpdate(tmp, controller.signal).then(res => {

                    })
                    .catch(err => {
                        console.error(err);
                        dispatch(setSnackbar({
                            type: "error",
                            message: "Session don't save",
                        }));

                    })
                    .finally(() => {
                        dispatch(reload());
                    });
            })

        }
    }
    useEffect(()=>{
        let startTime = moment("09:00", "HH:mm");

        props.sessions?.forEach((session) => {
            if (startTime > getSessionStartTime(session)) startTime = getSessionStartTime(session)
        });

        let startTime2 = moment(startTime.set('minute', 0).format("HH:mm"), "HH:mm");
        let hours = [];

        let h = moment("23:00", "HH:mm").diff(startTime,"hours");

        hoursCount.current = h;

        for (let i = 0; i <= h * 2; i++) {
            hours.push(moment(startTime2).add(i * 30, "minutes").format("HH:mm"))
        }

        setHoursToRender(hours);
        sessionRef.current = {}

        setState(getRenderDays())


    }, [props.data, props.sessions, admissionType])

    const getHeightForScroll = () => {
        let endTime = moment("23:00", "HH:mm");

        props.sessions?.forEach((session) => {
            let time = 0;
            session.bookedSessions.forEach((item)=> {
                if(!item.holdingPen) time += item.timeLen
            })
            let timeToAdd = time > session.maxTime? time: session.maxTime;

            if (endTime < getTimeEndForSession(session).add(timeToAdd, "minutes"))
                endTime = getTimeEndForSession(session).add(timeToAdd, "minutes")
        });

        return calcTopForHour(endTime) ;
    }

    useEffect(()=>{
        calendarScroll.current.scrollTop = 0;
    },[props.startDay])

    useEffect(()=>{
        if(props.selectedTime) {
            let start = configBA.timeOfDayRanges[props.selectedTime].startHour
            calendarScroll.current.scrollTop = calcTopForHour(start);
        }
    },[props.selectedTime])


    useEffect(() => {
        if(!timeLineVisible) {
            if (document.getElementById("time-line")){
                document.getElementById("time-line").style.display = "none";
                document.getElementById("time").style.display = "none";
            }
        }
        if(timeLineVisible) {
            const timeLine = () => {
                let myTime = moment().diff(moment(hoursToRender[0], "HH:mm"), "minutes");
                let top = ((myTime * hourHeight) / 60) + headerHeight - 1;

                if (top < hourHeight * hoursCount.current) {
                    if(document.getElementById("time-line")) {
                        document.getElementById("time-line").style.display = "block";
                        document.getElementById("time").style.display = "block";
                        document.getElementById("time-line").style.top = top + "px";
                        document.getElementById("time").style.top = ((myTime * hourHeight) / 60) + headerHeight - 9 + "px";
                        document.getElementById("time").innerText = moment().format("HH:mm");
                    }
                } else {
                    if (document.getElementById("time-line")){
                        document.getElementById("time-line").style.display = "none";
                        document.getElementById("time").style.display = "none";
                    }
                }
            }
            const iid = setInterval(timeLine, 5000);
            timeLine();

            return () => {
                clearInterval(iid);
            }
        }

    },[hoursToRender, hourHeight, timeLineVisible])

    useEffect(() => {
        let firstDay = moment(props.startDay);
        let lastDay = moment(props.startDay).add(dispatch(countDays()), "days");
        setTimeLineVisible((moment().isSameOrAfter(firstDay) && moment().isSameOrBefore(lastDay)));
        dispatch(setDraftModeOn(false));

    }, [props.data])


    const getSessionStartTime = (session) => {
        let time = moment.tz(session.day, timezone).format("HH:mm");
        if(session.importId && time === "00:00") time = configBA.timeOfDayRanges[session.timeOfDay.code].startHour
        else time = moment(session.day).format("HH:mm")
        return moment(time,"HH:mm");
    }


    const getSessionStartDateAndTime = (session) => {
        let timeUTC = moment.utc(session.day);
        let timeZone = moment.tz(session.day, timezone);

        if (session.importId && timeZone.format("HH:mm") === "00:00") {
            const startHour = configBA?.timeOfDayRanges[session.timeOfDay.code].startHour.split(":");
            const time = moment(session.day)
                .set('minute', startHour[1])
                .set('hour', startHour[0]);

            timeUTC = moment.utc(time);
        }

        return timeUTC.format("DD-MM-YYYY-HH-mm");
    }
    const getSessionStartDateAndTimeMoment = (session) => {
        let timeUTC = moment.utc(session.day);
        let timeZone = moment.tz(session.day, timezone);

        if (session.importId && timeZone.format("HH:mm") === "00:00") {
            const startHour = configBA?.timeOfDayRanges[session.timeOfDay.code].startHour.split(":");
            const time = moment(session.day)
                .set('minute', startHour[1])
                .set('hour', startHour[0]);

            return moment(time);
        }

        return moment(session.day);
    }

    const sessionIsImported = (session) => {
        let timeUTC = moment.utc(session.day);
        let timeZone = moment.tz(session.day, timezone);

        let someOldRecords = session.bookedSessions?.some((item) =>  item.holdingPen ?? moment.tz(item.startTime, timezone).format("HH:mm") === "00:00");

        if (session.importId && (timeZone.format("HH:mm") === "00:00" || someOldRecords)) {
            return true;
        }

        return false;
    }


    const getTimeEndForSession = (session) => {
        let time = 0;
        session.bookedSessions.forEach((item)=> {
            if(!item.holdingPen) time += item.timeLen
        })
        return getSessionStartTime(session).add(time > session.maxTime? time : session.maxTime, "minutes");
    }

    const getTimeEndForSessionMDU = (session) => {
        let times = {};

        session.bookedSessions.forEach((item)=> {
            if(!times.hasOwnProperty(item.workStationId)) times[item.workStationId] = 0;
            times[item.workStationId] += item.timeLen
        })

        let maxTime = 0;

        Object.keys(times).forEach((key) => {
            if(times[key] > maxTime) maxTime = times[key];
        })

        return getSessionStartTime(session).add(maxTime > session.maxTime? maxTime : session.maxTime, "minutes");
    }

    const getRenderDaysMDU = () => {
        let column = [];

        let day = moment(props.startDay);
        let sessionsDay = props.sessions?.filter(ad =>
            ad.day && moment.utc(ad.day).local().format("DD/MM/YYYY") === day.format("DD/MM/YYYY"))

        let allWorkStations = {};
        let sessionToEditTmp = [];

        sessionsDay.forEach((ses)=>{
            ses.workStations?.forEach((workStation) => {
                if(!allWorkStations[workStation.id]) allWorkStations[workStation.id] = workStation
            })

            if(!ses.workStations) {
                sessionToEditTmp.push(ses);
            }
        })

        setSessionToEdit(sessionToEditTmp);

        let listToReschedule = [];
        let haveSessionToAssigned = false;

        sessionsDay.forEach((ses, index)=> {
            ses.bookedSessions.filter((bookedSession) => {
                if (bookedSession.operationId && operations[bookedSession.operationId]) {
                    listToReschedule.push({
                        operationSessionDetails: bookedSession,
                        operation: operations[bookedSession.operationId]
                    });
                    if(!bookedSession.workStationId) {
                        haveSessionToAssigned = true;
                    }
                }
            });
        });

        Object.keys(allWorkStations).forEach((stationID) => {

            let containers = [];

            sessionsDay.forEach((ses, index)=>{
                let startTime = getSessionStartTime(ses);
                let endTime = getTimeEndForSessionMDU(ses);

                let overlap = false;
                let imported = false;

                if((sessionsDay[index+1] && endTime > getSessionStartTime(sessionsDay[index+1])) ||
                    (sessionsDay[index-1] && startTime < getTimeEndForSessionMDU(sessionsDay[index-1])))
                    overlap = true;
                if(sessionIsImported(ses))
                    imported = true;


                if(ses.workStations?.some((station) => station.id === stationID)){
                    let t = ses.bookedSessions.filter((bookedSession) => {
                        if(bookedSession.workStationId === stationID )
                            return bookedSession
                    })
                    t = _.sortBy(t, ses => {
                        return ses.listPos; //props.data[ses.operationId]?.bookedDate ||
                    });

                    containers.push({
                        session: ses,
                        items: t,
                        overlap: overlap,
                        imported: imported
                    })
                }

            })

            column.push({
                day: day,
                workStation: allWorkStations[stationID],
                containers: containers
            })

        });

        if(haveSessionToAssigned) {
            dispatch(setOperationsStatus(admissionStatusTypes.SCHEDULED));
            dispatch(setPatientsListToReschedule(listToReschedule))
        }
        else dispatch(setPatientsListToReschedule([]))

        return column;
    }

    const getRenderDays = () => {
        if(admissionType === admissionViewTypes.THEATRES)
            return getRenderDaysTCI()
        else
            return getRenderDaysMDU();
    }

    const getRenderDaysTCI = () => {
        let days = [];

        setHoldingAreaView(props.days === 1);

        for(let i = 0; i < props.days; i++) {
            let day = moment(props.startDay).add(i, "days");
            let sessions = props.sessions?.filter(ad =>
                ad.day && moment.utc(ad.day).local().format("DD/MM/YYYY") === day.format("DD/MM/YYYY")
            ).sort((a, b) => getSessionStartTime(a) - getSessionStartTime(b))

            let containers = [];
            let imported = false;

            sessions.forEach((session, index)=> {
                let overlap = false;

                let startTime = getSessionStartTime(session);
                let endTime = getTimeEndForSession(session);

                if((sessions[index+1] && endTime > getSessionStartTime(sessions[index+1])) ||
                    (sessions[index-1] && startTime < getTimeEndForSession(sessions[index-1])))
                    overlap = true;

                let t = session.bookedSessions;
                if(sessionIsImported(session)){
                    imported = true;

                    t = _.sortBy(session.bookedSessions, ses => {
                        return props.data[ses.operationId]?.listPos || 100;

                    });
                    t = _.sortBy(t, ses => {
                        return props.data[ses.operationId]?.bookedDate
                    });
                } else {
                    t = _.sortBy(session.bookedSessions, ses => {
                        return props.data[ses.operationId]?.bookedDate
                    });
                }


                containers.push({
                    session: session,
                    items: t, //sort by listPos
                    overlap: overlap,
                    imported: imported
                })
            })

            days.push({
                day: day,
                containers: containers,
                imported: imported
            })
        }

        return days;
    }

    const getItemTopPosition = (time, session, t) => {

        let timeTmp = moment.utc(time).format("HH:mm");
        let timeZoneTmp = moment.tz(time, timezone).format("HH:mm");

        if(session.importId && timeZoneTmp === "00:00") return t;
        else timeTmp = moment(time).format("HH:mm");

        let sessionTime = getSessionStartTime(session);
        let myTime = moment(timeTmp,"HH:mm").diff(moment(sessionTime, "HH:mm"), "minutes");
        return ((myTime / 60) * hourHeight) + 2 ;
    }


    const getItemTopPosition2 = (time, session) => {
        let timeTmp = moment(time,"HH:mm");

        let sessionTime = getSessionStartTime(session);
        let myTime = moment(timeTmp).diff(moment(sessionTime, "HH:mm"), "minutes");
        return ((myTime / 60) * hourHeight)  ;
    }

    const calcTopForSession = (session) => {
        let myTime = getSessionStartTime(session).diff(moment(hoursToRender[0], "HH:mm"), "minutes");
        return (myTime / 60) * hourHeight
    }

    const calcTopForHour = (hour) => {
        let myTime = moment(hour, "HH:mm").diff(moment(hoursToRender[0], "HH:mm"), "minutes");
        return (myTime / 60) * hourHeight
    }

    const calcHeightForSession = (container, oldView) => {
        if(oldView) {
            let time = 0;
            container.items.forEach((item)=> {
                time += (proceduresLen(props.data[item.operationId])/30*(hourHeight/2) - 1);
            })

            return time;
        }
        return ((container.session.maxTime / 60) * hourHeight + (container.session.locked? 4 : 2));
    }

    const calcMinHeightForSession = (container) => {
        return (container.session.maxTime / 60) * hourHeight;
    }

    const calcHeightForTimeSlot = (maxTime) => {
        return (maxTime / 60) * hourHeight - 4;
    }

    const countBackgroundPositionSession = (session) => {
        let myTime = getSessionStartTime(session).diff(moment(hoursToRender[0], "HH:mm"), "minutes");
        return ((30-myTime%30) / 60) * hourHeight
    }

    const countBackgroundPosition = () => {
        let myTime = 0;
        return ((30-myTime%30) / 60) * hourHeight
    }

    const handleScroll = () => {
        setScrollTop(calendarScroll.current.scrollTop)
    }

    const handleClick = (event, session, workStation = null) => {
        setSelectedSession(session);
        setClickedHour(null);
        setWorkStation(workStation);
        setAnchorEl(event.currentTarget);
    };

    const handleOpenNoteModal = (event, session) => {
        setSelectedSession(session);
        openSessionNoteModal()
    }

    const handleAddSessionClick = (day) => {
        setSelectedSession(null);
        setSelectedDay(day.format("DD/MM/YYYY"))
        openEditSessionModal();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [holdingAreaView, setHoldingAreaView] = useState(false);

    const handleOpenHoldingArea = () => {
        setAnchorEl(null);
        dispatch(setNewView(moment(selectedSession.day), CalendarViews.days1));
    }

    const handleEditSession = () => {
        openEditSessionModal();
        setAnchorEl(null);
    }

    const handleDeleteSession = () => {
        setAnchorEl(null);
        let sessionToSave = {
            ...selectedSession,
            _day: selectedSession.day,
            theatre: mapTheatreObject(selectedSession.theatre),
            active: false,
            status: "PENDING"
        };

        updateSession(sessionToSave)
    }

    const handleTimeSlot = () => {
        openTimeSlotModal();
        setAnchorEl(null);
    }
    const handleLockSession = () => {
        setAnchorEl(null);
        let sessionToSave = {
            ...selectedSession,
            _day: selectedSession.day,
            theatre: mapTheatreObject(selectedSession.theatre),
            locked: !selectedSession.locked
        };

        updateSession(sessionToSave)

    }

    const updateSession = (session) => {
        API.theatreSessionsUpdate(session, controller.signal).then(res => {
                dispatch(reload());
            })
            .catch(err => {
                console.error(err);

            })
            .finally(() => {
                // dispatch(setLoading(false));
            });
    }

    const getDayHeader = (containers, el) => {
        if(admissionType === admissionViewTypes.THEATRES)
            return getDayHeaderTCI(containers, el.day)
        else
            return getDayHeaderMDU(containers, el);
    }

    const getDayHeaderMDU = (containers, el) => {
        let timeMinutes = scrollTop * 60 / hourHeight;
        let maxTime = moment(hoursToRender[0], "HH:mm").add(timeMinutes, "minutes")
        let sessionToView = null;

        containers?.forEach((container) => {
            let startHour = getSessionStartTime(container.session);
            let endHour = getSessionStartTime(container.session).add(container.session.maxTime, "minutes")
            if((maxTime.isBefore(endHour) && maxTime.isAfter(startHour)) || maxTime.isSame(startHour))
                sessionToView = container;
        })

        let time = sessionToView? sessionToView.session.bookedSessions.filter((bookedSession) => {
            if(bookedSession.workStationId === el.workStation?.id)
                return bookedSession
        }).reduce((accumulator, s) => accumulator + s.timeLen, 0) : 0;



        let p = Math.floor(100*time/sessionToView?.session.maxTime) || 0;
        let color = "";
        let text = "";

        if(configBA) {
            Object.keys(configBA?.dayCardColorRanges).map((range)=> {
                if(p >= range) {
                    color = configBA?.dayCardColorRanges[range].color;
                    text = configBA?.dayCardColorRanges[range].text;
                }
            })
        }

        let isLocked = sessionToView? sessionToView.session.locked: false;

        return <div>
            <div className={classes.dayHeader}>
                <div className={classes.flexCenter}>
                    {el.workStation?.name}
                </div>



                {isLocked && getLockItem(sessionToView)}

                {sessionToView && <div className={classes.flexCenter}>
                    {sessionToView && sessionToView.session?.message &&
                        <IconButton onClick={(e) => handleOpenNoteModal(e, sessionToView?.session)}>
                            <NotesIcon/>
                        </IconButton>
                    }
                    <IconButton onClick={(e) => handleClick(e, sessionToView?.session, el.workStation)}>
                        <MoreVertIcon fontSize={"small"}/>
                    </IconButton>
                </div>}
            </div>
            <div className={classes.dayDetails}>
                {sessionToView &&
                <div className={classes.noSessionLabel} style={{color: color}}>
                    <CircleIcon color={color} fontSize={"10px"}/>
                    <div style={{marginLeft: 5}}> {text} </div>
                </div>
                }

                {!sessionToView && <div className={classes.noSessionLabel}> No Sessions </div>}
            </div>
        </div>
    }

    const getLockItem = (sessionToView) => {
        let text = "";
        if(sessionToView.session.lockedBy) text = `Locked by: ${sessionToView.session.lockedBy} (${moment(sessionToView.session.lockedDate).format("DD/MM/YYYY HH:mm")})`
        return <Tooltip title={text}>
            <div className={classes.lockedSession}>
                <div>(LOCKED)</div>
                <div><LockIcon/></div>
            </div>
        </Tooltip>
    }

    const sessionRef = React.useRef(null);

    const getDayHeaderTCI = (containers, day) => {
        let timeMinutes = scrollTop * 60 / hourHeight;
        let maxTime = moment(hoursToRender[0], "HH:mm").add(timeMinutes, "minutes")
        let sessionToView = null;

        containers?.forEach((container) => {
            let startHour = getSessionStartTime(container.session);
            let endHour = getTimeEndForSession(container.session);
            if((maxTime.isBefore(endHour) && maxTime.isAfter(startHour)) || maxTime.isSame(startHour))
                sessionToView = container;
        })

        let isNew = false;
        if(sessionRef.current && calendarScroll.current.scrollTop !== 0 && sessionRef.current[day]?.session?.id !== sessionToView?.session?.id) {
            isNew = true;
        }

        if(isNew) {
            let element = document.getElementById(moment(day).format("DD")+"_day_header");
            if(element) {
                element.style.backgroundColor = 'white';
                element.style.color = 'black';

                let el2 = document.getElementById(moment(day).format("DD")+"_day_header_title");
                if(el2) el2.style.display = "flex"

                setTimeout(() => {
                    const theme = window._getTheme();
                    element.style.backgroundColor = theme === "dark" ? "#373737" : "#d2d5d9";
                    element.style.color =  theme === "dark" ? "#ffffff" : "#000000";
                    if(el2) el2.style.display = "none"
                }, 1000);
            }
        }

        sessionRef.current = {
            ...sessionRef.current,
            [day]: sessionToView
        };

        let holdingTime = 0;
        let holdingCount = 0;
        let time = sessionToView? sessionToView.session.bookedSessions.reduce((accumulator, s) => {
            if(!s.holdingPen) return accumulator + s.timeLen;
            else {
                holdingCount++;
                holdingTime += s.timeLen;
                return accumulator;
            }
        }, 0) : 0;

        let isLocked = sessionToView? sessionToView.session.locked: false;

        return <div>
            <div className={clsx(classes.dayHeader, moment().isSame(moment(day),"date") && "today")} >
                <div className={classes.flexCenter} style={{width: "100%",  justifyContent: holdingAreaView? "":"space-between", columnGap: 5}}>
                    <div className={classes.flexCenter} style={{fontSize: "1.3rem"}}>
                        <div className={classes.dayNumber}>{moment(day).format("DD")}</div>
                        {moment(day).format("ddd")}
                    </div>

                    {sessionToView &&
                        <div style={{display: "flex", marginLeft: 10}}>
                            <div className={classes.specCode}>{sessionToView?.session?.specialty?.__code}</div>
                            {!isLocked && <div>
                                {sessionToView?.session.maxTime - time ?
                                    <div
                                        className={classes.time}> ({sessionToView?.session.maxTime - time - holdingTime} min) </div> :
                                    <div className={classes.fullSession}> (FULL)</div>
                                }
                            </div>
                            }
                            {isLocked && getLockItem(sessionToView)}
                        </div>
                    }
                </div>


                <div className={classes.flexCenter}>
                    {draftMode && <div style={{display: "flex", alignItems: "center"}}>
                        <AgyleButton
                            onClick={handleResetDraftState}
                            variant="text"
                            startIcon={<RestartAltIcon/>}
                        >
                            reset
                        </AgyleButton>

                        <div style={{margin: "0 5px"}}>
                            <AgyleButton
                                onClick={handleSaveDraftMode}
                                variant="contained"
                                disabled={!draftValid()}
                            >
                                Save
                            </AgyleButton>
                        </div>

                        <IconButton onClick={handleCancelDraft}>
                            <CloseIcon/>
                        </IconButton>
                    </div>
                    }

                    {!draftMode && holdingAreaView && !_.isEmpty(props.data) &&
                        <Tooltip title={!sessionsHaveAllPatients() ? "MISSING PATIENT RECORD": ""}>
                            <div>
                                <IconButton
                                    size={"small"}
                                    disabled={!(sessionsHaveAllPatients() && userCanManageScheduledList())}
                                    color={"primary"}
                                    onClick={handleOpenDraftMode}
                                >
                                    <EditIcon/>
                                </IconButton>
                            </div>
                        </Tooltip>
                    }

                        {sessionToView && !holdingAreaView && holdingCount !== 0 && <div className={classes.holdingIcon}> H </div>}
                        {sessionToView && sessionToView.session?.message &&
                            <IconButton onClick={(e) => handleOpenNoteModal(e, sessionToView?.session)}>
                                <NotesIcon/>
                            </IconButton>
                        }

                        {sessionToView && !draftMode &&
                            <IconButton disabled={draftMode} onClick={(e) => handleClick(e, sessionToView?.session)}>
                                <MoreVertIcon fontSize={"small"}/>
                            </IconButton>
                        }
                        {!sessionToView && !draftMode &&
                            <IconButton
                                disabled={!dispatch(hasBAPermission(Permissions.BA_CAN_ADD_NEW_T_SESSION, admissionType))}
                                onClick={(e) => handleAddSessionClick(day)}>
                                <AddIcon fontSize={"small"}/>
                            </IconButton>
                        }
                    </div>
            </div>

            <div className={classes.dayDetails} id={moment(day).format("DD")+"_day_header"}>
                <div className={classes.sessionHeader} id={moment(day).format("DD")+"_day_header_title"}>
                    {sessionToView? sessionToView?.session?.timeOfDay.code.toUpperCase()+ " Session": "No Sessions"}
                </div>
                {sessionToView &&
                    <div className={classes.flexCenter}>
                        <div className={classes.specColorMarker} style={{background: generateColor(sessionToView?.session?.specialty?.__code)}}/>
                        <div>
                            <div className={classes.sessionPerson}> Surg: {sessionToView.session.surgeon?.name}</div>
                            <div className={classes.sessionPerson}> Anaesth: {sessionToView.session.anaesthetists?.name}</div>
                        </div>

                    </div>
                }

                {!sessionToView &&
                    <div className={classes.noSessionLabel}> No Sessions </div>
                }
            </div>
        </div>
    }

    const draftValid = () => {
        let isValid = true;

        stateDraft.map((column) => {
            column?.containers.forEach((container) => {
                container.items.forEach((item) => {
                    if (item.overlap) isValid = false;
                    if (!item.holdingPen && moment(item.startTime).isBefore(container.session.day)) isValid = false;
                    if (!item.holdingPen && moment(item.startTime).add(item.timeLen, "minutes").isAfter(moment(container.session.day).add(container.session.maxTime, "minutes")))
                        isValid = false;
                });

            });
        });

        return isValid;
    };

    const [timeFormat, setTimeFormat] = useState(false);

    useEffect(()=> {
        let configType = admissionType === admissionViewTypes.THEATRES? "tciSchedule" : "mduSchedule";
        let configCard = configBA.cardSetting[configType];
        let timeFormatInMin = configBA.timeFormatInMinutes;

        if(agylePreference.bookedAdmissionsCardConfig[configType])
            configCard = agylePreference.bookedAdmissionsCardConfig[configType]
        
        if(agylePreference.bookedAdmissions.timeFormatInMinutes !== null)
            timeFormatInMin = agylePreference.bookedAdmissions.timeFormatInMinutes

        setCardConfig(configCard);
        setTimeFormat(timeFormatInMin);

    },[agylePreference, configBA])



    const handleOpenTimeSlotModal = (lockSession, sessionId, workStation, session) => {
        setSelectedTimeSlot(lockSession);
        setSelectedSession(session);
        setWorkStation(workStation);
        openTimeSlotModal();
    }


    const handleTimeSlotOpen = (e, session, workStation) => {
        if(!draftMode && userCanManageTimeSlot() && session?.status !== "history") {
            setSelectedSession(session);
            let timeMinutes = (e.nativeEvent.offsetY) * 60 / hourHeight;
            let maxTime = getSessionStartTime(session).add(timeMinutes, "minutes");
            const sessionDay = moment(session.day);
            maxTime.year(sessionDay.get('year'));
            maxTime.month(sessionDay.get('month'));
            maxTime.date(sessionDay.get('date'));
            maxTime.second(0);
            setClickedHour(maxTime);
            setWorkStation(workStation);
            openTimeSlotModal();
        }
    }

    const getStyleForSession = (container, imported, index) => {
        return {
            width: container.overlap? "48%":"100%",
            marginLeft: (container.overlap)? 50*(index%2)+"%": 0,
            top: calcTopForSession(container.session),
            height: calcHeightForSession(container, imported),
            minHeight: calcMinHeightForSession(container, imported),
            backgroundPosition: "0 "+ countBackgroundPositionSession(container.session)+"px",
            backgroundSize: "100% "+hourHeight/2+"px, "+hourHeight/2+"px 100%",
            background: imported? "#313233": "unset",
            borderLeft: config.specialtyColorForBA? ("2px solid " + generateColor(container?.session?.specialty?.__code)): "unset"
        }
    }
    const getStyleForDay = () => {
        return {
            height: hourHeight*hoursCount.current,
            width: getColumnWidth(true)
        }
    }
    const getStyleForCalendar = () => {
        let havesessions = state?.[0]?.containers?.length !== 0;
        return {
            width: holdingAreaView? `calc(100vw - ${havesessions? 680 : 445}px)`: "fit-content",
            display: "flex" ,
            marginLeft: 50,
            marginTop: 5,
            backgroundPosition: "0 "+ countBackgroundPosition()+"px",
            backgroundSize: "100% "+hourHeight/2+"px, "+hourHeight/2+"px 100%",
            height: getHeightForScroll()
        }
    }


    const getSessionId = (session, workStation) => {
        //name_00:00_sesionId_workstationId

        if(config.specialtyColorForBA) {
            let timeMinutes = scrollTop * 60 / hourHeight;
            let maxTime = moment(hoursToRender[0], "HH:mm").add(timeMinutes, "minutes")
            let sessionToView = null;

            let startHour = getSessionStartTime(session);
            let endHour = getTimeEndForSession(session);
            if((maxTime.isBefore(endHour) && maxTime.isAfter(startHour)) || maxTime.isSame(startHour))
                sessionToView = session;

            if(sessionToView === null) return "wrong_"+session?.id;

        }

        if(workStation)
            return session && !session.locked? "workstation_"+getSessionStartDateAndTime(session)+"_"+session?.id+"_"+ workStation.id: "no_session"
        else
            return session && (!session.locked  || draftMode)? "day_"+getSessionStartDateAndTime(session)+"_"+session?.id : "no_session"
    }

    const getStyleForSessionContent = (container, imported) => {
        return {
            position: "relative",
            height: calcHeightForSession(container, imported),
            minHeight: calcMinHeightForSession(container, imported),
            width: "100%",
        }
    }

    const handleTimeSlotClick = (e, item, id, workStation, session) => {
        if(!draftMode && userCanManageTimeSlot()) {
            e.stopPropagation();
            e.preventDefault();
            handleOpenTimeSlotModal(item, id, workStation, session);
        }
    }


    const renderTimeSlot = (item, index, timeTmp, session, workStation, overlapIndex) => {

        let height = calcHeightForTimeSlot(item.timeLen);
        let fontSize = height/2 < 12? height/2 : 12;
        return  <div id={"cardSlot_"+index+"_"+session.id+"_"+(workStation? workStation.id:"")}
                 key={index + "timeslot" + session.id}
                 onClick={(e) => handleTimeSlotClick(e, item, session.id, workStation, session)}
                 className={clsx(classes.itemTimeSlot, "timeslot_DRAFT")}
                 style={{
                     top: getItemTopPosition(item.startTime, session, 0),
                     width: item.overlap ? `calc(100% - ${(overlapIndex-1) * 40}px`: "100%",
                     marginLeft: item.overlap ? `calc(${(overlapIndex-1) * 40}px )`: "0px",
                     height: height
                 }}>

                {item.comment ? <span style={{fontSize: (fontSize+"px") }}> {item.comment} </span> : <i style={{fontSize: (fontSize+"px") }}>No reason added</i>}
             </div>
    }

    const handleOperationClick = (e, operationId) => {
        if(!draftMode) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(setMarkedOperation(props.data[operationId]))
        }

    }

    const [operationToEnd, setOperationToEnd] = useState(null);
    const [operationEndTime, setOperationEndTime] = useState(moment());


    const handleEndSurgeryModalOpen = (operation) => {
        setOperationToEnd(operation);
        setOperationEndTime(moment());
        openEndSurgeryModal()
    }

    const handleCloseEndSurgeryModal = () => {
        closeEndSurgeryModal()
        setOperationToEnd(null);
        setOperationEndTime(moment());
    }

    const handleEndSurgery = () => {
        let operationTmp = _.cloneDeep(operationToEnd);

        let patientTmp = _.cloneDeep(operationTmp.patient);

        delete operationTmp.sessiosObj;
        delete operationTmp.href;
        delete operationTmp.type;
        delete operationTmp.patient;
        operationTmp.endSurgery = moment.utc(operationEndTime).toISOString();

        API.admissionUpdate(operationTmp, controller.signal).then(
            (res) => {
                handleCloseEndSurgeryModal();
                dispatch(reload());
                dispatch(setSnackbar({type: "success", message: "Surgery ended"}));

                let pData = {
                    name: operationTmp.patientName,
                    nhs: operationTmp.patientId,
                    hospital: operationTmp.patientId,
                    dob: operationTmp.patientDob
                }

                let data = {
                    operation: {
                        ...operationTmp,
                        patient: patientTmp
                    },
                    ...pData
                }

                let formName = operationTmp.opType === "MDU"? "surgeryMDU": "surgery";

                APIForm.getSaveForm( {data: data} , operationTmp.patientId, formName)
                    .then((response)=>{
                            dispatch(setSnackbar({type: "success", message: "DOR genereted"}));
                            return !!response;
                        },
                        (er)=> {
                            return false
                        }
                    );

            }
        )

    }


    const renderOperation = (item, index, session, timeTmp, draft = false, overlapIndex, workStation) => {

        let operation =  props.data[item.operationId];
        if(draft) operation = stateDataDraft[item.operationId];

        return <div className={clsx(classes.itemContent, "card_container_DRAFT")}
                    key={"admission" + item.operationId+index}
                    id={draft? `admissioncard_${item.operationId}_${session.id}_${workStation? workStation.id: ""}`: "admission_card_scroll_" + item.operationId}
                    onClick={(e) => handleOperationClick(e, item.operationId)}
                    style={{top: getItemTopPosition(item.startTime, session, timeTmp),
                        width: item.overlap ? `calc(100% - ${(overlapIndex-1) * 40}px`: "100%",
                        marginLeft: item.overlap ? `calc(${(overlapIndex-1) * 40}px )`: "0px",
                        outline: item.overlap? "2px dashed red": ""
                    }}>

            {props.data[item.operationId] &&
                <AdmissionPatientCard ad={operation}
                                      calendar
                                      cardName={"DRAFT"}
                                      hourHeight = {hourHeight}
                                      endSurgery={handleEndSurgeryModalOpen}
                                      markedOperation={markedOperation ? markedOperation.id === props.data[item.operationId].id : false}
                                      cardConfig={cardConfig}
                                      timeFormat={timeFormat}
                                      extraKey={`_${session.id}_${workStation? workStation.id: ""}`} index={index}/>
            }

        </div>

    }

    const sessionsHaveAllPatients = () => {
        let sessionsHavePatients = true;

        state?.[0]?.containers?.forEach((container)=>{
            container.items.forEach((item, index) => {
                if(operations[item.operationId]?.patient === null) sessionsHavePatients = false;
            });
        })
        return sessionsHavePatients;
    }

    const userCanManageScheduledList = () => {
        if(admissionViewTypes.THEATRES === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_TCI_SL, admissionType));
        if(admissionViewTypes.MDU === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_ON_SL, admissionType));
    }

    const handlePointerStart = (e, operationId) => {
        let item = props.data[operationId];

        if(item.patient !== null && markedOperation && markedOperation.id === item.id && userCanManageScheduledList()) {
            e.preventDefault();
            e.stopPropagation();

            let el = $(`#${item.id}`);
            let elClone = el.clone();

            elClone.css({
                height: `${proceduresLen(item) / 30 * (hourHeight / 2) - 2}px`,
                width: 200,
                overflow: "hidden"
            });

            const ghost = $("#dandd");
            ghost.css("display", "none");
            $("#dandd_2").css("display", "none");
            ghost.html(elClone);

            dispatch(setAdmissionDnD({
                item
            }));
        }
    };

    const renderOperationInHoldingPen = (item, index, session, timeTmp, draft = false) => {

        return <div className={clsx(classes.itemContentHoldingPen, "card_holding_container_DRAFT")}
                    key={"admission" + item.operationId+index}
                    id={draft? `admissioncard_${item.operationId}_${session.id}`: "admission_card_scroll_" + item.operationId}
                    onClick={(e) => {
                        handleOperationClick(e, item.operationId)
                    }}
                    onPointerDown={(e) => handlePointerStart(e, item.operationId)}
                    style={{ maxWidth: 200, top: getItemTopPosition(props.data[item.operationId]?.bookedDate, session, timeTmp)}}
        >

            {props.data[item.operationId] &&
                <AdmissionPatientCard ad={props.data[item.operationId]}
                                      hourHeight = {hourHeight}
                                      endSurgery={handleEndSurgeryModalOpen}
                                      markedOperation={markedOperation? markedOperation.id === props.data[item.operationId].id : false}
                                      cardConfig={cardConfig}
                                      timeFormat={timeFormat}
                                      index={index}/>
            }

        </div>

    }

    const getColumnWidth = (isDay = false) => {
        if(admissionType === admissionViewTypes.THEATRES) {
            return `calc((100vw - 450px - ${(holdingAreaView && isDay)? "240px": "0px"}) / ${props.days})`
        }
        else return `calc((100vw - 470px) / ${state?.length})`
    }

    const getTimeLineWidth = () => {
        if(admissionType === admissionViewTypes.THEATRES) {
            let dayWidth = (window.innerWidth - 450 - (holdingAreaView? 240: 0)) / props.days;
            if(dayWidth < 300) return props.days * 310
            else return dayWidth * props.days;
        } else {
            let dayWidth = (window.innerWidth - 450) / state?.length;
            if(dayWidth < 300) return state?.length * 310
            else return dayWidth * state?.length;
        }
    }

    const renderAvailableSlot = (index, top, minutes) => {
        return <div
            id={"available_slot_"+ index}
            className={classes.availableSlot}
            style={{
                top: top,
                height: ((minutes/60)*hourHeight)
            }}
        >
            Available Slot
            <div>
                {minutes} minutes
            </div>
        </div>
    }


    const getAvailableSlots = (container) => {
        if(!container.imported || admissionType !== admissionViewTypes.THEATRES) {
            let sessionStartHour = moment(container.session.day);

            let sessionMaxTime = container.session.maxTime;
            let sessionEndHour = moment(container.session.day).add(sessionMaxTime, "minutes");
            let hourStart = moment(sessionStartHour);
            let sorted  = _.clone(container.items)?.sort(function(x, y){ return x.startTime > y.startTime? 1: -1;});
            sorted = _.filter(sorted, e => {
                return !e.holdingPen;
            });
            let slots = [];


            sorted.forEach((op, index) => {

                let opStartTime = moment(op.startTime);
                let opEndTime = moment(opStartTime).add(op.timeLen, "minutes");

                if(opStartTime.diff(hourStart, "minutes") >= 0 ){
                    slots.push({
                        station: op.workStationId,
                        start: hourStart.format("HH:mm"),
                        end: opStartTime.format("HH:mm"),
                        len: opStartTime.diff(hourStart, "minutes")
                    })
                }

                hourStart =  opEndTime;

            });
            if(sessionEndHour.diff(hourStart, "minutes") > 1) {
                slots.push({
                    station: sorted[0]?.workStationId,
                    start: hourStart.format("HH:mm"),
                    end: sessionEndHour.format("HH:mm"),
                    len: sessionEndHour.diff(hourStart, "minutes")
                })
            }

            if(slots.length === 0) {
                if(sessionEndHour.diff(moment(hourStart), 'minutes') >= 0){
                    slots.push({
                        // station: sorted[0]?.workStationId,
                        start: moment(hourStart).format("HH:mm"),
                        len: sessionMaxTime
                    })
                }
            }

            return slots;
        } else {
            return []
        }

    }


    const renderColumn = (ind, el) => {
        return  <span key={ind+"dayColumn"}>

            <div className={classes.day} style={getStyleForDay(el.imported)}>
                            {el.containers.map((container,index) => {
                                let timeInPx = 0;
                                return <span key={index+"_session_"+container.session.id}>

                                    <div className={container.session.locked ? clsx(classes.sessionWithBorder, classes.locked) : classes.sessionWithBorder}
                                         style={getStyleForSession(container, el.imported, index)}>

                                        <div style={getStyleForSessionContent(container, el.imported)}
                                             onClick={(e) => {handleTimeSlotOpen(e, container.session, el.workStation)}}
                                             id={getSessionId(container.session, el.workStation)}>

                                            {container.session && container.items?.map((item, index) => {
                                                if(!item.holdingPen) {
                                                    let currentTimeInPx = timeInPx;
                                                    timeInPx += (proceduresLen(props.data[item.operationId])/30*(hourHeight/2) - 1);

                                                    if(item.operationId !== null)
                                                        return renderOperation(item, index, container.session, currentTimeInPx)
                                                    else {
                                                        return renderTimeSlot(item, index, currentTimeInPx, container.session, el.workStation)
                                                    }
                                                }
                                            })}


                                            {(!_.isEmpty(props.data)  || container?.items?.length === 0) && getAvailableSlots(container).map((item, index) => {
                                                return  renderAvailableSlot(index, getItemTopPosition2(item.start, container.session), item.len);
                                            })}
                                        </div>
                                    </div>
                                </span>
                            })}
                    </div>
                </span>
    }

    const renderColumnDraftMode = (ind, el) => {
        return  <span key={ind+"dayColumn"}>
            <div className={clsx("session", classes.day)} style={getStyleForDay(el.imported)}>
                            {el.containers.map((container,index) => {
                                let timeInPx = 0;
                                let overlapIndex = 0;
                                return <span key={index+"_session_"+container.session.id}>

                                    <div id={"sessionId_"+container.session?.id}
                                         className={container.session.locked ? clsx(classes.session, classes.locked, "SESSION_DRAFT_BOX") : clsx(classes.session, "SESSION_DRAFT_BOX")}
                                         style={getStyleForSession(container, el.imported, index)}>

                                        <div style={{...getStyleForSessionContent(container, el.imported), outline: "2px dashed #2180F7",  borderRadius: "2px"}}
                                             className={"SESSION_DRAFT"}
                                             onClick={(e) => {handleTimeSlotOpen(e, container.session, el.workStation)}}
                                             id={getSessionId(container.session, el.workStation)}>

                                            {container.session && container.items?.map((item, index) => {
                                                if(!item.holdingPen) {
                                                    let currentTimeInPx = timeInPx;
                                                    timeInPx += (item.timeLen*hourHeight/60) - 1;

                                                    if(index > 0 && moment(item.startTime).isSameOrAfter(moment(container.items[index-1].startTime).add(container.items[index-1].timeLen, "minutes"))) {
                                                        overlapIndex = 0;
                                                    }
                                                    if(item.overlap) overlapIndex++;
                                                    else overlapIndex = 0;

                                                    if(item.operationId !== null){
                                                        return renderOperation(item, index, container.session, currentTimeInPx, true, overlapIndex, el.workStation)
                                                    } else {
                                                        return renderTimeSlot(item, index, currentTimeInPx, container.session, el.workStation, overlapIndex)
                                                    }
                                                }
                                            })}

                                        </div>
                                        </div>


                                </span>
                            })}
                    </div>

                </span>
    }

    const handleCloseSessionModal = () => {
        closeEditSessionModal()
        setSelectedDay(null);
    }

    const getHisPatientListBySessions = () => {
        if(patientsListToReschedule.length !== 0) {
            let day = moment(props.startDay);
            let sessionsDay = props.sessions?.filter(ad =>
                ad.day && moment.utc(ad.day).local().format("DD/MM/YYYY") === day.format("DD/MM/YYYY"));
            return sessionsDay;
        }
        return [];
    }

    const handleCloseTimeSlotModal = () => {
        closeTimeSlotModal();
        setSelectedTimeSlot(null);
        setSelectedSession(null);
        setWorkStation(null);
    }
    const handleCloseSessionNoteModal = () => {
        closeSessionNoteModal();
        setSelectedSession(null);
    }

    const testOperationsOverlap = (tmpState) => {
            tmpState.map((column)=>{
                column.containers.forEach((container) => {
                    container.items = container.items.sort((a, b) => moment(a.startTime).diff(b.startTime))

                    container.items.filter((item) => !item.holdingPen).forEach((item, index) => {
                        item.overlap = false;
                        let myEndTime = moment(item.startTime).add(item.timeLen, "minutes");

                        container.items.filter((item) => !item.holdingPen).forEach((item2, index2) => {
                            let start = moment(item2.startTime);
                            let end = moment(item2.startTime).add(item2.timeLen, "minutes");

                            if ((start.isAfter(item.startTime) && start.isBefore(myEndTime)) ||
                                (end.isAfter(item.startTime) && end.isBefore(myEndTime)) ||
                                (moment(item.startTime).isAfter(start) && myEndTime.isBefore(end))) {
                                item.overlap = true;
                            }

                        });

                    })
                })
            })

        return tmpState
    }

    const [operationToEditTime, setOperationToEditTime] = useState(null);

    const handleOpenTimeChangeModal = (operationId, minutes) => {
        if(stateDataDraft[operationId].proceduresLen.length === 1) {
            setStateDataDraft((data) => {
                let dataTmp = _.cloneDeep(data);
                dataTmp[operationId].proceduresLen[0] = minutes;

                return dataTmp;
            })
        } else {
            setOperationToEditTime({
                operationId: operationId,
                newTime: minutes
            })
            openEditOperationTimeModal();
        }
    }


    const getContainerById = (id, state) => {
        let container;

        if(id[3] && id[3] !== "") {
            container = state.find((state) => state.workStation.id === id[3]).containers.find((container) => container.session.id === id[2])
        } else {
            container = state[0].containers.find((container) => container.session.id === id[2])
        }

        return container
    }

    const setGhostTime = (event, time, minutes) => {
        const ghostTime = $("#dandd_2");

        ghostTime.css({
            left: (event.pageX - 50) + "px",
            top: `${event.pageY - 40}px`,
            backgroundColor: "#313233",
            borderRadius: "5px",
            height: "23px",
            textAlign: "center",
            display: "block"
        });

        ghostTime.html(moment(time).add(minutes, "minutes").format("HH:mm"));
    }

    useEffect(() => {
        if(draftMode && $( ".SESSION_DRAFT" ) && state && state[0]) {
            $( ".SESSION_DRAFT").resizable({
                handles: "s",
                resize: function( event, ui ) {
                    let height = ui.size.height;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_")
                    let container = getContainerById(id, stateDraft);

                    let lastItem = container.items[container.items.length - 1];

                    let endTime = moment(lastItem.startTime).add(lastItem.timeLen, "minutes");
                    let newEndSessionTime = moment(container.session.day).add(minutes, "minutes");
                    if(endTime.isAfter(newEndSessionTime)) {

                        let minTime = moment(endTime).diff(container.session.day, "minutes");
                        let minHeight =  minTime * hourHeight / 60;
                        ui.size.height = minHeight;
                    }

                },
                stop: function( event, ui ) {
                    let height = ui.size.height;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_")

                    setStateDraft((state) => {
                        let tmpState = _.cloneDeep(state);
                        let container = getContainerById(id, tmpState);

                        container.session.maxTime = minutes;
                        return tmpState;
                    });

                }
            });

            $( ".SESSION_DRAFT" ).draggable({
                axis: "y",
                opacity: "0.5",
                zIndex: "10000",
                drag: function( event, ui ) {
                    ui.position.left = 0;
                },
                stop: function( event, ui ) {
                    let top = ui.position.top;
                    ui.helper[0].style.top = 0;
                    let minutes = Math.floor(top * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_")

                    setStateDraft((state) => {
                        let tmpState = _.cloneDeep(state);
                        let container = getContainerById(id, tmpState);

                        container.session.day = moment(container.session.day).add(minutes, "minutes").toISOString();

                        container.items.forEach((item, index) => {
                            item.startTime = moment(item.startTime).add(minutes, "minutes")
                        });

                        return testOperationsOverlap(tmpState)
                    })

                }
            });

            $( ".timeslot_DRAFT" ).draggable({
                axis: "y",
                opacity: "0.5",
                zIndex: "10000",
                helper: 'clone',
                revert: 'invalid',
                drag: function( event, ui ) {
                    ui.position.left = 0;
                },
                stop: function( event, ui ) {
                }
            });

            $( ".timeslot_DRAFT" ).resizable({
                handles: "s",
                delay: 150,
                opacity: "0.5",
                zIndex: "10000",
                resize: function( event, ui ) {
                    let height = ui.size.height + 5;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_");
                    let container = getContainerById(id, stateDraft);
                    let item = container.items[id[1]];

                    setGhostTime(event, item.startTime, minutes)

                },
                stop: function( event, ui ) {
                    let height = ui.size.height + 5;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_")

                    $("#dandd_2").empty();

                    setStateDraft((state) => {
                        let tmpState = _.cloneDeep(state);
                        let container = getContainerById(id, tmpState);
                        let item = container.items[id[1]];
                        item.timeLen = minutes;

                        return testOperationsOverlap(tmpState)
                    })
                }
            });
            $( ".card_DRAFT" ).resizable({
                handles: "s",
                delay: 150,
                resize: function( event, ui ) {
                    let height = ui.size.height + 7;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_");
                    let container = getContainerById(id, stateDraft);
                    let item = container.items.find((item) => item.operationId === id[1]);

                    setGhostTime(event, item.startTime, minutes)

                },
                stop: function( event, ui ) {
                    let height = ui.size.height + 7;
                    let minutes = Math.floor(height * 60 / hourHeight);
                    let id = ui.helper[0].id.split("_")
                    let container = getContainerById(id, stateDraft);
                    let item = container.items.find((item) => item.operationId === id[1]);

                    $("#dandd_2").empty();

                    handleOpenTimeChangeModal(item.operationId, minutes)

                    setStateDraft((state) => {
                        let tmpState = _.cloneDeep(state);
                        let container = getContainerById(id, tmpState);
                        let item = container.items.find((item) => item.operationId === id[1]);

                        item.timeLen = minutes;

                        return testOperationsOverlap(tmpState)
                    })
                }
            });


            $( "#sessionId_"+sessionRef.current[state[0]?.day]?.session.id).droppable({
                accept: ".card_holding_container_DRAFT",
                drop: function( event, ui ) {
                    let dropSessionId = event.target.id.split("_");
                    let id = ui.helper.prevObject[0].id.split("_")

                    if(dropSessionId[1] === id[2]) {
                        let top = ui.position.top;
                        let minutes = Math.floor(top * 60 / hourHeight);

                        $("#dandd_2").empty();

                        setStateDraft((state) => {
                            let tmpState = _.cloneDeep(state);
                            let container = getContainerById(id, tmpState);

                            if(id[0] === "cardSlot") {
                                let item = container.items[id[1]];
                                item.startTime = moment(container.session.day).add(minutes, "minutes").toISOString();
                            } else {
                                let item = container.items.find((item) => item.operationId === id[1]);
                                item.startTime = moment(container.session.day).add(minutes, "minutes").toISOString();
                                item.holdingPen = false;
                            }

                            return testOperationsOverlap(tmpState)
                        })
                    }
                }
            });

            $( ".card_holding_container_DRAFT" ).draggable({
                axis: "x, y",
                opacity: "0.5",
                helper: 'clone',
                revert: 'invalid',
                appendTo: '#sessionId_'+ sessionRef.current[state[0].day]?.session.id,
                start: function(e, ui)
                {
                    let id = ui.helper.prevObject[0].id.split("_")
                    let container = getContainerById(id, stateDraft);
                    let item = container.items.find((item) => item.operationId === id[1]);
                    let heightItem = item.timeLen * hourHeight / 60;

                    $(ui.helper).css("height", heightItem+"px");
                    $(ui.helper).css("max-height", heightItem+"px");
                    $(ui.helper).addClass(classes.patientCardBackground)
                    $(ui.helper).css("overflow", "hidden");
                },
                drag: function(event, ui ) {
                    ui.helper.prevObject[0].style.display = "none";
                },
                stop: function( event, ui ) {
                    ui.helper.prevObject[0].style.display = "block";
                }
            });

            $( ".card_container_DRAFT" ).draggable({
                axis: "x, y",
                opacity: "0.5",
                zIndex: "10000",
                helper: 'clone',
                revert: 'invalid',
                drag: function( event, ui ) {

                   // ui.position.left = 0;
                    if(ui.position.top < 0) ui.position.top = 0;
                    let top = ui.position.top;

                    let minutes = Math.floor(top * 60 / hourHeight);

                    let id = ui.helper.prevObject[0].id.split("_")
                    let container = getContainerById(id, stateDraft);
                    let item = container.items.find((item) => item.operationId === id[1]);
                    let minutesLen = item.timeLen;

                    if(minutes+minutesLen > container.session.maxTime) {
                        ui.position.top = (container.session.maxTime - minutesLen) / 60 * hourHeight;
                        minutes = Math.floor(ui.position.top * 60 / hourHeight);
                    }

                    setGhostTime(event, container.session.day, minutes)

                },
                stop: function( event, ui ) {
                    $("#dandd_2").empty();
                }
            });

            stateDraft.map((column)=>{
                column.containers.forEach((container)=>{
                    $( "#"+getSessionId(container.session, column.workStation)).droppable({
                        drop: function( event, ui ) {
                            let top = ui.position.top;
                            let minutes = Math.floor(top * 60 / hourHeight)
                            let dropSessionId = event.target.id.split("_");
                            let id = ui.helper.prevObject[0].id.split("_")


                            setStateDraft((state) => {
                                let tmpState = _.cloneDeep(state);
                                let container = getContainerById(id, tmpState);


                                if(id[0] === "cardSlot") {
                                    let item = container.items[id[1]];
                                    item.startTime = moment(container.session.day).add(minutes, "minutes").toISOString();
                                } else {
                                    let itemIndex = container.items.findIndex((item) => item.operationId === id[1]);
                                    container.items[itemIndex].startTime = moment(container.session.day).add(minutes, "minutes").toISOString();

                                    if(admissionType === admissionViewTypes.MDU && container.items[itemIndex].workStationId !== dropSessionId[3]) {
                                        container.items[itemIndex].workStationId = dropSessionId[3]

                                        let containerToDrop = tmpState.find((state) => state.workStation.id === dropSessionId[3]).containers.find((container) => container.session.id === id[2])
                                        containerToDrop.items.push(container.items[itemIndex])
                                        container.items.splice(itemIndex, 1);
                                    }

                                }

                                return testOperationsOverlap(tmpState)
                            })

                        }
                    });
                })

            })

        }

    },[draftMode, stateDraft, hourHeight, sessionRef.current?.[state?.[0]?.day]])

    const addTime = (time, index, operationId) => {
        setStateDataDraft((data) => {
            let dataTmp = _.cloneDeep(data);
            dataTmp[operationId].proceduresLen[index] += time;
            return dataTmp;
        })
    }

    const getTimeToManage = () =>{
        let actualTime = stateDataDraft[operationToEditTime.operationId].proceduresLen.reduce((sum, time) => sum + time, 0)
        return operationToEditTime?.newTime - actualTime;
    }

    const proceduresTimesValid = () =>{
        let wrongTimeItems = stateDataDraft[operationToEditTime.operationId].proceduresLen.find((len) =>  len < 0);
        return wrongTimeItems === undefined
    }

    const renderOperationTimeModal = () => {
        let timeToManage = getTimeToManage();
        return  <div>
            <div style={{textAlign: "center", marginBottom: 20, fontWeight: "bold"}}> Time to manage: {timeToManage} min </div>
            {operationToEditTime && stateDataDraft[operationToEditTime.operationId].procedures.map((proc,index)=> {
                    return <Grid container spacing={1} alignItems={"center"}>
                        <Grid item xs={1} style={{textAlign: "right"}}> {index + 1}. </Grid>
                        <Grid item xs={5}> {proc.__description} </Grid>
                        <Grid item xs={1} style={{textAlign: "center"}}>
                            <IconButton
                                size={"small"}
                                onClick={() => {
                                    addTime(-1, index, operationToEditTime.operationId)
                                }}
                            >
                                <RemoveIcon/>
                            </IconButton>
                        </Grid>
                        <Grid item xs={1} style={{textAlign: "center"}}> {stateDataDraft[operationToEditTime.operationId].proceduresLen[index]} min</Grid>
                        <Grid item xs={1} style={{textAlign: "center"}}>
                            <IconButton
                                size={"small"}
                                onClick={() => {
                                    addTime(1, index, operationToEditTime.operationId)
                                }}
                            >
                                <AddIcon/>
                            </IconButton>
                        </Grid>

                        <Grid item xs={3} style={{display: "flex", justifyContent: "center" }}>
                            <AgyleButton
                                size="small"
                                onClick={()=>addTime(timeToManage, index, operationToEditTime.operationId)}
                                startIcon={<ControlPointDuplicateIcon/>}
                            >
                                Add ({timeToManage} min)
                            </AgyleButton>
                        </Grid>
                    </Grid>
                }
            )}
        </div>
    }
    const handleCloseTimeModal = () => {
        closeEditOperationTimeModal();
    }

    const userCanManageSession = () => {
        if(admissionType === admissionViewTypes.THEATRES) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_SESSIONS, admissionType))
        if(admissionType === admissionViewTypes.MDU) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_SESSIONS, admissionType))
    }

    const userCanManageTimeSlot = () => {
        if(admissionType === admissionViewTypes.THEATRES) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_LOCKED_SLOTS, admissionType))
        if(admissionType === admissionViewTypes.MDU) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_LOCKED_SLOTS, admissionType))
    }

    return(
        <>
            <div className={classes.sliderHolder}>
                {admissionType === admissionViewTypes.MDU && <div style={{display: "flex", alignItems: "center"}}>
                        {draftMode && <div style={{display: "flex", alignItems: "center"}}>
                            <AgyleButton
                                onClick={handleResetDraftState}
                                variant="text"
                                startIcon={<RestartAltIcon/>}
                            >
                                reset
                            </AgyleButton>

                            <div style={{margin: "0 5px"}}>
                                <AgyleButton
                                    onClick={handleSaveDraftMode}
                                    variant="contained"
                                    disabled={!draftValid()}
                                >
                                    Save
                                </AgyleButton>
                            </div>

                            <IconButton onClick={handleCancelDraft}>
                                <CloseIcon/>
                            </IconButton>
                        </div>
                        }
                    {!draftMode &&
                    <Tooltip title={!sessionsHaveAllPatients() ? "MISSING PATIENT RECORD": ""}>
                        <div>
                            <IconButton
                                size={"small"}
                                disabled={!(sessionsHaveAllPatients() && userCanManageScheduledList())}
                                color={"primary"}
                                onClick={handleOpenDraftMode}
                            >
                                <EditIcon/>
                            </IconButton>
                        </div>
                    </Tooltip>
                    }
                    </div>
                }
                <div style={{maxWidth: 200, width: 200, display: "flex", height: 44, alignItems: "center"}}>
                    <Slider
                        step={10}
                        value={hourHeight}
                        min={50}
                        max={700}
                        onChange={(event)=> {dispatch(setHourHeight(event.target.value))} } />
                </div>

            </div>
            <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={selectedDay? "Add Session" : (admissionType === admissionViewTypes.THEATRES? "Edit Session" : "Edit MDU Session")}
                open={isEditSessionModalOpen}
                onClose={handleCloseSessionModal}
                width={"lg"}
                fullWidth
                disableActions
                closeButtonOnHeader
            >
                <SessionModal session = {selectedSession}  selectedDay = {selectedDay} onClose={handleCloseSessionModal}/>
            </AgyleDialog>

            <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={"Do you want to end the surgery?"}
                open={isEndSurgeryModalOpen}
                onClose={handleCloseEndSurgeryModal}
                submitText={"Save"}
                onSave={handleEndSurgery}
            >
                <div className={classes.patientCardHolder}>
                    <AdmissionPatientCard ad={operationToEnd}
                                          hourHeight = {200}
                                          cardConfig={cardConfig}
                                          timeFormat={timeFormat}
                                          index={"index"}/>
                </div>

                <AgyleDatePicker
                    value={operationEndTime}
                    label={"End Time"}
                    type="dateTime"
                    textFieldClass={classes.textFieldClass}
                    onChange={setOperationEndTime}
                    error={false}
                />

            </AgyleDialog>

            {operationToEditTime && <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={"Manage the time difference of procedures"}
                fullWidth
                width={"md"}
                disableActionsCloseButton
                open={isEditOperationTimeModalOpen}
                submitText={"accept"}
                disableSubmit={!(getTimeToManage() === 0 && proceduresTimesValid())}
                onSave={handleCloseTimeModal}
            >
                <div className={classes.timeModalBody}>
                    {operationToEditTime && renderOperationTimeModal()}
                </div>

            </AgyleDialog>
            }

            {isTimeSlotModalOpen && <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={selectedTimeSlot? "Edit Time Slot": "Lock Time Slot"}
                open={isTimeSlotModalOpen}
                onClose={handleCloseTimeSlotModal}
                width={"sm"}
                disableActions
                closeButtonOnHeader
            >

                <LockTimeSlotModal
                    clickedHour={clickedHour}
                    onClose={handleCloseTimeSlotModal}
                    slotToEdit={selectedTimeSlot}
                    clickedWorkStation={clickedWorkStation}
                    session = {selectedSession}
                />

            </AgyleDialog> }

            {isSessionNoteModalOpen && <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={"Session Note"}
                open={isSessionNoteModalOpen}
                onClose={handleCloseSessionNoteModal}
                width={"md"}
                disableActions
                closeButtonOnHeader
            >

               <div> {selectedSession.message}</div>

            </AgyleDialog> }
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{'aria-labelledby': 'basic-button'}}
            >
                <MenuItem onClick={handleLockSession} disabled={!userCanManageSession()}>{selectedSession?.locked? "Unlock Session": "Lock Session"}</MenuItem>
                <MenuItem onClick={handleTimeSlot} disabled={!userCanManageTimeSlot() || selectedSession?.status === "history"}>Lock Time Slot</MenuItem>
                <MenuItem onClick={handleEditSession} disabled={!userCanManageSession()}>Edit Session</MenuItem>
                {admissionType === admissionViewTypes.THEATRES &&
                    <MenuItem onClick={handleOpenHoldingArea}>
                        Holding Area <div className={classes.holdingNumber}> {_.filter(selectedSession?.bookedSessions, (e) => {return e.holdingPen})?.length} </div>
                    </MenuItem>
                }
                <MenuItem onClick={handleDeleteSession} disabled={!userCanManageSession() || selectedSession?.bookedSessions.length !== 0}>Delete Session</MenuItem>
            </Menu>



            <div className={clsx("scroll-normal-white", classes.calendarContainer)}
                 onScroll={handleScroll}
                 ref={calendarScroll}>

                {state !== null && state.length === 0 && sessionToEdit.length === 0 &&
                    <div className={classes.addSessionButton}>
                        <AgyleButton
                            variant="outlined"
                            startIcon={<AddIcon/>}
                            disabled={!dispatch(hasBAPermission(Permissions.BA_CAN_ADD_MDU_SESSION, admissionType))}
                            onClick={(e) => handleAddSessionClick(moment(props.startDay))}
                        >
                            ADD SESSION
                        </AgyleButton>
                    </div>
                }
                <div style={{position: "relative"}}>

                    {state && state.length !== 0 && sessionToEdit.length === 0 && <>
                        <div id="time-line" className={classes.timeLine} style={{width: getTimeLineWidth()}}/>
                        <div id="time" className={classes.currentTime}/>
                        <div id="calendar-time" className={classes.times}>
                            {hoursToRender.map((h, index) => {
                                return <div key={"time"+index} className={classes.timeLabel} style={{top: index*(hourHeight/2)-14+headerHeight}}> {h} </div>
                            })}
                        </div>
                    </>
                    }


                    {sessionToEdit.length === 0 && !draftMode &&
                    <>
                        <div className={classes.stickyDayContainer}>
                            <div className={classes.stickyDayHolder}>
                                <div className={classes.stickyDayHolderItem}/>
                                {state?.map((el, ind) => {
                                    return <div key={ind+el.day}>
                                        <div className={classes.dayHeaderContainer} style={{width: getColumnWidth()}}>
                                            {getDayHeader(el.containers, el)}
                                        </div>
                                        <div className={classes.headerLine}/>
                                    </div>
                                })}
                            </div>
                        </div>

                        <div>
                          <div className={classes.calendarContent} style={getStyleForCalendar()}>
                                {state?.map((el, ind) => {
                                    return renderColumn(ind, el)
                                })}
                            </div>
                        </div>
                    </>
                    }

                    {sessionToEdit.length === 0 && draftMode &&
                    <>
                        <div className={classes.stickyDayContainer}>
                            <div className={classes.stickyDayHolder}>
                                <div className={classes.stickyDayHolderItem}/>
                                {stateDraft?.map((el, ind) => {
                                    return <div key={ind+el.day}>
                                        <div className={classes.dayHeaderContainer} style={{width: getColumnWidth()}}>
                                            {getDayHeader(el.containers, el)}
                                        </div>
                                        <div className={classes.headerLine}/>
                                    </div>
                                })}
                            </div>
                        </div>

                        <div>

                            <div className={classes.calendarContent} style={getStyleForCalendar()}>
                                {stateDraft?.map((el, ind) => {
                                    return renderColumnDraftMode(ind, el)
                                })}
                            </div>

                        </div>


                    </>
                    }


                    {sessionToEdit.length !== 0 && moment(props.startDay).isAfter(transferStartDate) &&

                    <div className={classes.addWorkstationButton}>
                        {sessionToEdit && sessionToEdit.map((session, index) => {
                            return <div>
                                <AgyleButton
                                    variant="outlined"
                                    color={"success"}
                                    startIcon={<EditIcon/>}
                                    disabled={!dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_SESSIONS, admissionType))}
                                    onClick={(e) => {
                                        setSelectedSession(session);
                                        openEditSessionModal();
                                    }}
                                >
                                    Add workstations to {session.timeOfDay.description} SESSION
                                </AgyleButton>
                            </div>
                        })}
                    </div>
                    }

                    {/*MDU - old data list */}
                    {moment(props.startDay).isBefore(transferStartDate) &&
                    <div style={{padding: "10px 50px"}}>
                        {patientsListToReschedule && cardConfig && getHisPatientListBySessions()?.map((session)=>{
                            return <div>
                                <div className={classes.dayHeader}>
                                    <div>{session.timeOfDay.description} SESSION</div>
                                </div>

                                {session.bookedSessions?.map((item)=> {
                                    return <div style={{margin: "0 10px 10px 10px"}}
                                                onClick={(e) => handleOperationClick(e, item.operationId)}>
                                        <AdmissionPatientCard ad={props.data[item.operationId]}
                                                              hourHeight = {50} markedOperation={markedOperation ? markedOperation.id === props.data[item.operationId].id : false}
                                                              cardConfig={cardConfig}
                                                              timeFormat={timeFormat}
                                                              extraKey={"_s"} index={"index"}/>
                                    </div>
                                })
                                }
                            </div>;
                        })
                        }
                    </div>
                    }
                </div>
            </div>
            <div>
                {holdingAreaView && sessionRef.current  &&
                <div id={"holding_" + sessionRef.current[state[0].day]?.session.id}
                     style={{opacity: sessionRef.current[state?.[0]?.day] !== null? 1: 0}}
                     className={clsx(classes.holdingContainer, "scroll-normal-white")}>

                    <div className={classes.holdingTitle}> Holding Area {sessionRef.current[state[0].day]?.session.timeOfDay.code}</div>
                    <span>
                                    {sessionRef.current && sessionRef.current[state[0].day]?.session.bookedSessions?.map((item, index) => {
                                        if (item.holdingPen) {
                                            return renderOperationInHoldingPen(item, index, sessionRef.current[state[0].day].session, 0, true)
                                        }
                                    })}
                                </span>
                </div>
                }
            </div>
        </>)
};

export default AgyleCalendarDays;
